import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormControl, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule, MatRowDef } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import BusinessPartnerInterlocutorAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/businness-partner-interloculor/businness-partner-interloculor.entity';
import { BusinessPartnerFunctionAttributes } from '@albatrosdeveloper/ave-models-package';
import BusinessPartnerAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity';

import { ReplaySubject, Subject, take, takeUntil } from 'rxjs';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { getCode } from 'app/utils/method';
import { ICreatePaymentBrand } from './interfaces/payment-brand.interface';
import PaymentBrandAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/payment-masters/payment-type/payment-brands/payment-brands.entity';
import { PaymentBrandService } from './payment-brand.service';


@Component({
  selector: 'app-payment-brand',
  styleUrl: './payment-brand.component.scss',
  templateUrl: './payment-brand.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    MatSelectModule,
    MatTabsModule,
    NgxMatSelectSearchModule,
  ],
})
export class PaymentBrandComponent {
  getCode = getCode

  currentCreatePaymentBrand: ICreatePaymentBrand = this.initializePaymentBrand();
  currentUpdateBusinessPartnerChain: PaymentBrandAttributes | undefined;
  
 isEditMode : boolean;
 protected _onDestroy = new Subject<void>();
  constructor(
    private readonly paymentBrandService: PaymentBrandService,
    public dialogRef: MatDialogRef<PaymentBrandComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any // Optional: if you want to pass data
  ) {
    this.isEditMode = !!data;
    if (this.isEditMode) {
        this.currentCreatePaymentBrand = { 
            ...data,
    }; 
}
}

  private initializePaymentBrand(): ICreatePaymentBrand {
    return {
       code: '',
       name: '',
       commission: 0,
       taxRetainment: 0,
       accountingAccount: '',
       costCenter: '',
       accountingKey: '',
       com_accountingAccount:'',
       com_costCenter: '',
       com_accountingKey: '',
       ret_accountingAccount:'',
       ret_costCenter: '',
       ret_accountingKey: ''
    };
  }

  save() {
    this.dialogRef.close(this.currentCreatePaymentBrand);
  }
}
